import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import ContratacoesVigentesService from "../../../services/ContratacoesVigentesService";
import qs from "query-string"
import _ from "lodash"
import {getByAtribute} from "../../../utils/formatar";
import CargoService from "../../../services/CargoService";
import ProdutoService from "../../../services/ProdutoService";
import moment from "moment/moment";
import ContratacoesStore from "./ContratacoesFiltroStore";

export default class ContratacoesVigentesStore extends ContratacoesStore {

    @observable contratacoesvigentesLista;
    @observable loading;
    @observable filtros;

    constructor(props) {
        super(props);
        this.loading = false;
        this.contratacoesvigentesLista = [];

        this.ContratacoesVigentesService = new ContratacoesVigentesService()
    }

    carregarTabela = () => {
        this.loading = true;
        const loadingPromises = Promise.all([
            this.ContratacoesVigentesService.listarContratacoesVigentes(_.pickBy(this.filtros, _.identity)).then(response => {
                this.contratacoesvigentesLista = response.data;
            }).catch(error => {
                console.log(error);
            })
        ]);
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    };

    setLista(value) {
        this.contratacoesvigentesLista = value;
    }
}